import { create } from "../../../common/utils/zustand_state_manager";
import { useControlePatrimonioServices } from "./use_services";

import { IControlePatrimonioRepository } from "../../../features/controledePatrimonio/domain/repositories/ControledePatrimonio";
import { ControlePatrimonioRepository } from "../../../features/controledePatrimonio/data/repositories/ControlePatrimonio_Repository";

/**
 * useControlePatrimonioRepositories
 */

type State = {
  controlePatrimonioRepository: IControlePatrimonioRepository;
};

export const useControlePatrimonioRepository = create<State>((set, get) => {
  const { controlePatrimonioService } = useControlePatrimonioServices.getState();

  return {
    controlePatrimonioRepository: new ControlePatrimonioRepository(controlePatrimonioService),
  };
});
